<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import Jcqklrlb from "./Jcqklrlb";
import JcqklrForm from "./JcqklrForm";
export default {
    name: "Zjxxrk",
    components: { Jcqklrlb, JcqklrForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 单据状态
                state: null,
                // 是否编辑状态
                showPage: "Jcqklrlb"
            }
        };
    },
    computed: {
        compName() {
            return this.editProps.showPage;
        }
    }
};
</script>
